var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:(_vm.$options.embedStyle)},[_c('iframe',{class:_vm.iframeClasses,style:(_vm.iframeStyle),attrs:{"src":_vm.src,"sandbox":_vm.provider.sandbox,"allowfullscreen":"true","referrerpolicy":"strict-origin-when-cross-origin","width":_vm.width,"height":_vm.height}})])
}
var staticRenderFns = []

export { render, staticRenderFns }